module.exports = __webpack_public_path__ + "img/blogSamplePic.5c676615.png";